const DISPLAY_KEYS = ['label', 'text', 'title']

const translateDisplayValue = (vm, value) => {
  if (typeof value !== 'string') return value
  return vm.$te(value) ? vm.$t(value) : value
}

const translateDisplayObject = (vm, item) => {
  if (!item || typeof item !== 'object' || Array.isArray(item)) return item

  let translated = item

  DISPLAY_KEYS.forEach(key => {
    if (typeof item[key] !== 'string') return

    const value = translateDisplayValue(vm, item[key])
    if (value === item[key]) return

    translated = {
      ...translated,
      [key]: value,
    }
  })

  return translated
}

const translateDisplayList = (vm, items) => {
  if (!Array.isArray(items)) return items
  return items.map(item => translateDisplayObject(vm, item))
}

const installI18nDisplayHelpers = Vue => {
  const { prototype } = Vue

  prototype.$tFields = function tFields(fields) {
    return translateDisplayList(this, fields)
  }

  prototype.$tOptions = function tOptions(options) {
    return translateDisplayList(this, options)
  }

  prototype.$tDisplay = function tDisplay(value) {
    return translateDisplayValue(this, value)
  }
}

export default installI18nDisplayHelpers
